import { Component, Inject, InjectionToken, signal } from '@angular/core';

export const OVERLAY_PORTAL_DATA = new InjectionToken<any>('OverlayPortalData');
@Component({
    selector: 'app-spinner-overlay',
    templateUrl: './spinner-overlay.component.html',
    styleUrls: ['./spinner-overlay.component.css'],
})
export class SpinnerOverlayComponent {
    public showImage = signal(true);
    constructor(@Inject(OVERLAY_PORTAL_DATA) public _showImage) {
        this.showImage.set(_showImage);
    }
}
